export default __webpack_public_path__ + "static/media/TIBIA_SAGITAL_LEFT.d3af916a.jpg";